import React from "react";
import Blocks from "../Components/blocks";
import Navbar from "../Components/Navbar";

const Homepage = () => {
  return (
    <>
      <Navbar />

      <div className="flex px-4 sm:px-6 lg:px-8">
        <div className="w-full">
          <Blocks />
        </div>
      </div>
    </>
  );
};

export default Homepage;
